<ng-container *ngrxLet="ssl$ as ssl">
    <!-- TLS Handshake failure results in a defined client_cipher_list, since this field is only generated
    when TLS handshake fails due to no shared cipher. -->
    <ng-container *ngIf="!ssl.client_cipher_list; else tlsHandshakeFailed">
        <div class="log-cinematic-section-ssl__column-group">
            <!-- 1st column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.fullTlsFingerprintLabel | vtranslate }}
                </div>
                <div
                    *ngIf="ssl.client_fingerprints?.full_tls_fingerprint as fullFingerprint; else noData"
                    logFilter
                    property="client_fingerprints.full_tls_fingerprint"
                    [value]="fullFingerprint"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ fullFingerprint }}
                </div>
            </div>

            <!-- 2nd column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.filteredTlsFingerprintLabel | vtranslate }}
                </div>
                <div
                    *ngIf="ssl.client_fingerprints?.filtered_tls_fingerprint as filteredFingerprint; else noData"
                    logFilter
                    property="client_fingerprints.filtered_tls_fingerprint"
                    [value]="filteredFingerprint"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ filteredFingerprint }}
                </div>
            </div>

            <!-- 3rd column -->
            <div logCinematicSectionColumn>
                <div
                    logFieldTitle
                    [withMarginTop]="false"
                >
                    {{ l10nKeys.normalizedFingerprintLabel | vtranslate }}
                </div>
                <div
                    *ngIf="ssl.client_fingerprints?.normalized_tls_fingerprint as normalizedFingerprint; else noData"
                    logFilter
                    property="client_fingerprints.normalized_tls_fingerprint"
                    [value]="normalizedFingerprint"
                    (onFilterAdd)="logCinematicStore.closeCinematic()"
                >
                    {{ normalizedFingerprint }}
                </div>
            </div>
        </div>

        <avi-data-grid
            [config]="sslGridConfig"
            [rows]="ssl | logSslGridRows"
        ></avi-data-grid>
    </ng-container>

    <ng-template #tlsHandshakeFailed>
        <avi-data-grid
            [config]="clientSuppliedCiphersGridConfig"
            [rows]="ssl.client_cipher_list.identified_ciphers"
        ></avi-data-grid>
    </ng-template>
</ng-container>

<ng-template
    #sslVersionFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.sslVersion; else noData"
        logFilter
        property="ssl_version"
        [value]="row.sslVersion"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.sslVersion | vtranslate }}
    </span>
</ng-template>

<ng-template
    #sslCertTypeFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.sslCertType; else noData"
        logFilter
        property="ssl_cipher"
        [operator]="FilterOperatorType.CONTAINS"
        [value]="'auth:' + row.sslCertType"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.sslCertType | vtranslate }}
    </span>
</ng-template>

<ng-template
    #sniHostnameFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.sniHostname; else noData"
        logFilter
        property="sni_hostname"
        [value]="row.sniHostname"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.sniHostname | vtranslate }}
    </span>
</ng-template>

<ng-template
    #sslPfsFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.sslPfs; else noData"
        logFilter
        property="ssl_cipher"
        [operator]="FilterOperatorType.CONTAINS"
        [value]="'PFS:' + row.sslPfs"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.sslPfs | vtranslate }}
    </span>
</ng-template>

<ng-template
    #sslEncFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.sslEnc; else noData"
        logFilter
        property="ssl_cipher"
        [operator]="FilterOperatorType.CONTAINS"
        [value]="'enc:' + row.sslEnc"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.sslEnc | vtranslate }}
    </span>
</ng-template>

<ng-template
    #oscpStatusFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        *ngIf="row.oscpStatus; else noData"
        logFilter
        property="ocsp_status_resp_sent"
        [value]="row.ocspStatus"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row.oscpStatus | vtranslate }}
    </span>
</ng-template>

<ng-template
    #clientSuppliedCiphersFieldTemplateRef
    let-row
    let-index="index"
>
    <span
        logFilter
        property="client_cipher_list.identified_ciphers"
        [value]="row"
        (onFilterAdd)="logCinematicStore.closeCinematic()"
    >
        {{ row }}
    </span>
</ng-template>

<ng-template #noData>
    <span logEmptyField></span>
</ng-template>
